import invariant from 'invariant';
import normalizeUrl from 'normalize-url';
import qs from 'qs';

import { QUERY_KEY_PREFIX_VALUES } from './constants';

export function fullUrl(url, params) {
  const normalizedUrl = normalizeUrl(url, { stripWWW: false });
  const normalizedParams = params && qs.stringify(params, {
    sort: (a, b) => a.localeCompare(b),
    arrayFormat: 'brackets'
  });
  return normalizedParams ? `${normalizedUrl}/?${normalizedParams}` : normalizedUrl;
}

export default function generateQueryKey({
  params,
  prefix,
  url
}) {
  invariant(url, "generateQueryKey: requires 'url'");

  // ensure we don't have query parameters in the base url
  invariant(!/\?[^#]/.test(url), "generateQueryKey: url parameters should be passed as 'params' for optimal caching");

  // ensure we don't introduce an ad-hoc prefix
  prefix = Array.isArray(prefix) ? prefix : [prefix];
  if (prefix[0]) {
    const invalidPrefixes = prefix.filter(p => !QUERY_KEY_PREFIX_VALUES.includes(p));
    invariant(
      invalidPrefixes.length === 0,
      `Invalid prefixes [${invalidPrefixes.join(', ')}] not present in QUERY_KEY_PREFIX_VALUES`
    );
  }

  return [...prefix, fullUrl(url, params)].filter(Boolean);
}
